/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {isEmpty} from 'react-redux-firebase'
import PageLoading from '../../components/app/page-loading'
import PageScaffold from '../../components/app/page-scaffold'
import PageSectionTitle from '../../components/app/page-section-title'
import {BaseLayout} from '../../components/layout'
import {routes} from '../../utils/config'
import StudentSelector from './student-selector'
import StudentStats from './student-stats'

const StudentProgress = () => {
  const {course} = useSelector(state => state.firestore?.data)
  const {enrollments} = useSelector(state => state.firestore?.ordered)
  const [currentStudent, setCurrentStudent] = useState(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (!isEmpty(enrollments)) {
      setCurrentStudent(enrollments[currentIndex])
    }
  }, [enrollments, currentIndex])

  const handleNext = incrementer => {
    const totStudents = enrollments.length
    setCurrentIndex((totStudents + currentIndex + incrementer) % totStudents)
  }

  if (!currentStudent) {
    return <PageLoading />
  }

  return (
    <BaseLayout>
      <PageScaffold pageTitle={routes.studentProgress.name}>
        <PageSectionTitle sectionTitle="Student Selector" />
        <StudentSelector handleNext={handleNext} student={currentStudent} />
        <PageSectionTitle sectionTitle="Current Chapter" />
        <StudentStats course={course} student={currentStudent.data} />
      </PageScaffold>
    </BaseLayout>
  )
}

export default StudentProgress
